import { Alert } from 'antd';

import useNotificationMessages from '../../hooks/common/useNotificationMessages';

import { IdType } from 'types/common';
import { INotificationProps } from './Notification.types';
import { NotificationType } from 'types/internalNotifications';

import './Notification.styles.scss';

const Notification = ({ data, onDelete }: INotificationProps) => {
  const messages = useNotificationMessages();

  const closable = data.msg_type === NotificationType.CLOSABLE;
  const message = messages[data.msg] || data.msg;

  const handleDelete = (id: IdType, isInApp?: boolean) => {
    onDelete(id, isInApp);
  };

  return (
    <Alert
      showIcon
      type="warning"
      title={message}
      closable={closable}
      onClose={() => handleDelete(data.id, data.isInApp)}
      className="np-internal-notifications__notification"
    />
  );
};

export default Notification;
